import { getFacebookUploadStatus, uploadFacebookTokenToBelay } from '../../../utils/requests/belay_requests';
import { populateFollowerRequests } from './followerRequests';
import { populateFindFriends } from './findFriends';

const SET_FACEBOOK_BELAY_STATUS = 'SET_FACEBOOK_BELAY_STATUS';

export const setBelayFacebookStatus = payload => {
  return dispatch => {
    dispatch({ type: SET_FACEBOOK_BELAY_STATUS, payload });
  };
};

export const getFacebookStatus = () => {
  return dispatch => {
    getFacebookUploadStatus()
      .then(res => {
        const { status } = res.contactUploads.facebook;
        dispatch(setBelayFacebookStatus(status));
      })
      .catch(err => console.log('Error retrieving facebookUpload status', err));
  };
};

export const populateInitialConnections = () => {
  return dispatch => {
    dispatch(getFacebookStatus());
    dispatch(populateFollowerRequests());
    dispatch(populateFindFriends());
  };
};

export const populateBelayToken = () => {
  return dispatch => {
    dispatch(populateInitialConnections());
  };
};

export const submitFacebookTokenToBelay = token => {
  return dispatch => {
    uploadFacebookTokenToBelay(token)
      .then(resp => {
        const { status } = resp;
        dispatch(setBelayFacebookStatus(status));
      })
      .catch(err => {
        console.log('ERR', err);
      });
  };
};

export const defaultBelayState = {
  facebook: {
    facebookStatus: null,
    appId: null
  }
};

export default function belay(state = defaultBelayState, action) {
  switch (action.type) {
    case SET_FACEBOOK_BELAY_STATUS:
      return {
        ...state,
        facebook: { ...state.facebook, facebookStatus: action.payload }
      };
    default:
      return state;
  }
}
